export default __webpack_public_path__ + "static/media/480_dummy2016-sportbekleidung01-mobile-de.d483cf61.png";